export default __webpack_public_path__ + "static/media/Titel_image_CSI_DH.aa3d56be.jpg";